import { useRef, useState } from "react";
import { Avatar, Dropdown, Menu, Button } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  DownOutlined,
  SmileOutlined,
} from "@ant-design/icons";

import { NavLink, Link } from "react-router-dom";

import { useSelector } from "react-redux";
/*
import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  styled,
} from "@mui/material";

import InboxTwoToneIcon from "@mui/icons-material/InboxTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import AccountBoxTwoToneIcon from "@mui/icons-material/AccountBoxTwoTone";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);
*/
const items = [
  {
    key: "1",
    label: <Link to="/daftar">Registrasi</Link>,
  },
  {
    key: "2",
    label: <Link to="/lupa-password">Lupa Password</Link>,
  },
  {
    key: "3",
    label: <Link to="/login">Login</Link>,
  },
];

const login_items = [
  {
    key: "1",
    label: <Link to="/profile">Profil</Link>,
  },
  {
    key: "2",
    label: <Link to="/password">Ganti Password</Link>,
  },
  {
    key: "3",
    label: <Link to="/logout">Logout</Link>,
  },
];

function HeaderUserbox() {
  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);

  const ref = useRef(null);

  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottom">
      <Button
        type="primary"
        shape="round"
        icon={<UserOutlined />}
        size="default"
      >
        Masuk/Daftar
      </Button>
    </Dropdown>
  );
  /*
          <Button type="text" style={{ padding: 0 }}>
          <Avatar size="large" icon={<UserOutlined />} />
        </Button>

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar
          variant="rounded"
          alt={currentUser.name}
          src={currentUser.avatar}
        />

        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser.roles}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          {
            //<Avatar variant="rounded" alt={user.name} src={user.avatar} />
          }
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {currentUser.roles}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/akun/profile/details" component={NavLink}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          {/*
          <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem>
          /}
          <ListItem button to="/akun/profile/settings" component={NavLink}>
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary="Account Settings" />
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            fullWidth
            component={NavLink}
            to="/auth/logout"
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
  */
}

export default HeaderUserbox;
